<div class="efetivos_page">
  <!-- ── HEADER ───────────────────────────────────────── -->
  <div class="page-header">
    <div>
      <h1>Gestão de Efectivos</h1>
      <p>
        {{ totalColaboradores }} colaboradores registados
      </p>
    </div>

    <div class="page-actions">
      <button
        class="btn-web-secondary"
        (click)="filtrosPainelAberto = true"
      >
        <i class="ri-filter-3-line"></i>
        Filtros 
      </button>

      <button
        class="btn-web-primary"
        (click)="criarEfetivo()"
      >
        <i class="fas fa-plus"></i>
        Novo Efectivo
      </button>
    </div>
  </div>

  <!-- ── FILTER TABS & TOOLBAR ───────────────────────── -->
  <div
    class="filters-row"
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    "
  >
    <!-- TABS -->
    <div
      class="filter-tabs"
      style="
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      "
    >
      <button
        class="filter-chip"
        [class.active]="activeTab === 'todos'"
        (click)="setActiveTab('todos')"
      >
        Todos
        ({{ countPorEstado["todos"] || 0 }})
      </button>

      <button
        class="filter-chip"
        [class.active]="activeTab === 'Ativo'"
        (click)="setActiveTab('Ativo')"
      >
        Ativos
        ({{ countPorEstado["Ativo"] || 0 }})
      </button>

      <button
        class="filter-chip"
        [class.active]="activeTab === 'Inativo'"
        (click)="setActiveTab('Inativo')"
      >
        Inativos
        ({{ countPorEstado["Inativo"] || 0 }})
      </button>

      <button
        class="filter-chip"
        [class.active]="activeTab === 'Afastado'"
        (click)="setActiveTab('Afastado')"
      >
        Afastados
        ({{ countPorEstado["Afastado"] || 0 }})
      </button>

      <button
        class="filter-chip"
        [class.active]="activeTab === 'Suspensos'"
        (click)="setActiveTab('Suspensos')"
      >
        Suspensos
        ({{ countPorEstado["Suspensos"] || 0 }})
      </button>

      <button
        class="filter-chip"
        [class.active]="activeTab === 'Ferias'"
        (click)="setActiveTab('Ferias')"
      >
        Férias
        ({{ countPorEstado["Ferias"] || 0 }})
      </button>

      <button
        class="filter-chip"
        [class.active]="activeTab === 'De_Folga'"
        (click)="setActiveTab('De_Folga')"
      >
        De Folga
        ({{ countPorEstado["De_Folga"] || 0 }})
      </button>
    </div>

    <!-- TOOLBAR -->
    <div
      class="toolbar-actions"
      style="
        display: flex;
        gap: 12px;
        align-items: center;
      "
    >
      <div class="search-box">
        <i class="fas fa-search"></i>

        <input
          type="text"
          placeholder="Pesquisar efetivo..."
          (input)="onSearchInput($event)"
        />
      </div>

      <p-select
        [options]="postos"
        optionLabel="nome"
        optionValue="id"
        placeholder="Todos os postos"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
        (onChange)="onPostoFilterChange($event)"
        filter="true"
      >
      </p-select>
    </div>
  </div>

  <!-- ── LISTA DE EFETIVOS ───────────────────────────── -->
  <div class="listar-membro-content">
    <app-lista-efetivos
      [pagination]="pagination"
      [skeletonLoading]="skeletonLoading"
      [fotoPreviewMap]="fotoPreviewMap"

      (pageChange)="onPageChange($event)"

      (filterChange)="aplicarFiltros($event)"

      (deleteEfetivo)="confirmarDelete($event)"

      (verPerfil)="verDetalhe($event)"

      (editar)="editar($event)"

      (toggleEstado)="toggleEstado($event)"

      (suspender)="abrirAcaoDrawer($event, 'suspender')"

      (afastar)="abrirAcaoDrawer($event, 'afastar')"

      (reativar)="reativar($event)"
    >
    </app-lista-efetivos>
  </div>
</div>

<!-- ── FILTROS OVERLAY ──────────────────────────────── -->
<div
  class="filtros-overlay"
  [class.open]="filtrosPainelAberto"
  (click)="filtrosPainelAberto = false"
></div>

<!-- ── FILTROS DRAWER ──────────────────────────────── -->
<div
  class="filtros-drawer"
  [class.open]="filtrosPainelAberto"
>
  <div class="filtros-header">
    <h3 class="fd-title">
      <i class="ri-equalizer-3-line"></i>
      Filtros de Efetivos
    </h3>

    <button
      type="button"
      (click)="filtrosPainelAberto = false"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div
    class="filtros-body"
    [formGroup]="filtrosForm"
  >
    <!-- NOME -->
    <div class="filtro-grupo">
      <label>Nome</label>

      <input
        class="form-input"
        formControlName="nome"
        placeholder="Pesquisar por nome..."
      />
    </div>

    <!-- BI -->
    <div class="filtro-grupo">
      <label>Nº BI</label>

      <input
        class="form-input"
        formControlName="numBI"
        placeholder="Número do BI..."
      />
    </div>

    <!-- GÉNERO -->
    <div class="filtro-grupo">
      <label>Género</label>

      <p-select
        formControlName="genero"
        [options]="generos"
        optionLabel="label"
        optionValue="value"
        placeholder="Todos"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <!-- ESTADO -->
    <div class="filtro-grupo">
      <label>Estado</label>

      <p-select
        formControlName="EstadoEfetivo"
        [options]="estadoOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Todos"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <!-- FUNÇÃO -->
    <div class="filtro-grupo">
      <label>Função</label>

      <p-select
        formControlName="IdFuncao"
        [options]="funcoes"
        optionLabel="label"
        optionValue="value"
        placeholder="Ex: Agente, Supervisor..."
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <!-- CATEGORIA -->
    <div class="filtro-grupo">
      <label>Categoria</label>

      <p-select
        formControlName="IdCategoria"
        [options]="categorias"
        optionLabel="designacao"
        optionValue="id"
        placeholder="Ex: Vigilante..."
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <!-- TELEFONE -->
    <div class="filtro-grupo">
      <label>Telefone</label>

      <input
        class="form-input"
        formControlName="numTelefone"
        placeholder="Ex: 923 456 789"
      />
    </div>

    <!-- MEC -->
    <div class="filtro-grupo">
      <label>MEC</label>

      <input
        class="form-input"
        formControlName="CodigoMec"
        placeholder="Ex: MEC-00123"
      />
    </div>

    <!-- DATA ADMISSÃO DE -->
    <div class="filtro-grupo">
      <label>Data</label>

      <input
        type="date"
        class="form-input"
        formControlName="dataAdmissaoDe"
      />
    </div>
  </div>

  <!-- FOOTER DOS FILTROS -->
  <div class="filtros-footer">
    <button
      type="button"
      class="btn-web-secondary"
      style="flex: 1"
      (click)="limparFiltros()"
    >
      <i class="fas fa-undo"></i>
      Limpar
    </button>

    <button
      type="button"
      class="btn-web-primary"
      style="flex: 2"
      (click)="aplicarFiltrosDrawer()"
    >
      <i class="fas fa-check"></i>
      Aplicar
    </button>
  </div>
</div>

<!-- ── CRIAR EFETIVO ────────────────────────────────── -->
<app-criar-efetivo
  [(visible)]="mostrarDrawer"
  (saved)="loadEfetivos()"
>
</app-criar-efetivo>

<!-- ── EDITAR EFETIVO ───────────────────────────────── -->
<app-editar-efetivo
  [visible]="mostrarDrawerEditar"
  (visibleChange)="onEditarDrawerVisibleChange($event)"
  [efetivoId]="efetivoIdParaEditar"
  (saved)="loadEfetivos()"
>
</app-editar-efetivo>

<!-- ── FICHA DO EFETIVO ─────────────────────────────── -->
<app-ficha-efetivo-drawer
  [(visible)]="fichaDrawerVisible"
  [efetivoId]="fichaEfetivoId"
  [pendingAction]="fichaPendingAction"
  (editarClicked)="editar({ id: $event })"
  (statusChanged)="onFichaStatusChanged()"
>
</app-ficha-efetivo-drawer>
